import { useState } from "react";
import { useSelector } from "react-redux";
import { useAddProjectMutation } from "../../features/projects/projectApi";
import { useGetTeamsQuery } from "../../features/teams/teamsApi";

export default function AddProjectModal({ open, control }) {
    const [title, setTitle] = useState("");
    const [team, setTeam] = useState(null);
    const { user: loggedInUser } = useSelector((state) => state.auth) || {};
    const {data: teams} = useGetTeamsQuery();
    const [addProject] = useAddProjectMutation();


    const handleSubmit = (e) => {
        e.preventDefault();
        if(team === "" || title === "") {
            return;
        }
        const data = {
            title,
            teamId: team,
            timestamp: new Date().getTime(),
            state: "Backlog",
            createdBy: loggedInUser
        };
        addProject(data);
        control();
        setTitle("");
        setTeam(null);
    };

    return (
        open && (
            <>
                <div
                    onClick={control}
                    className="fixed w-full h-full inset-0 z-10 bg-black/50 cursor-pointer"
                ></div>
                <div className="rounded w-[400px] lg:w-[600px] space-y-8 bg-white p-10 absolute top-1/2 left-1/2 z-20 -translate-x-1/2 -translate-y-1/2">
                    <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
                        Add Project
                    </h2>
                    <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
                        <div className="rounded-md shadow-sm -space-y-px">
                            <div>
                                <label htmlFor="description" className="sr-only">
                                    Title
                                </label>
                                <textarea
                                    id="title"
                                    name="title"
                                    type="text"
                                    required
                                    className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-violet-500 focus:border-violet-500 focus:z-10 sm:text-sm mt-2"
                                    placeholder="Title"
                                    value={title}
                                    onChange={(e) => setTitle(e.target.value)}
                                />
                            </div>
                            <div>
                                <select className="form-select appearance-none
                                    block
                                    w-full
                                    px-3
                                    py-1.5
                                    text-base
                                    font-normal
                                    text-gray-700
                                    bg-white bg-clip-padding bg-no-repeat
                                    border border-solid border-gray-300
                                    rounded
                                    transition
                                    ease-in-out
                                    mt-2
                                    focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none" aria-label="Default select example"
                                    defaultValue={team}
                                    onChange={e => setTeam(e.target.value)}
                                >
                                    <option>Select Team</option>
                                    {teams && teams
                                        ?.slice()
                                        ?.sort((a ,b) => b?.timestamp - a?.timestamp)
                                        ?.filter(team => team.users.find(user => user?.id == loggedInUser?.id))
                                        ?.map(team => 
                                        <option key = {team.id} value = {team.id}>{team.name}</option>
                                    )}
                                </select>
                            </div>
                        </div>

                        <div>
                            <button
                                type="submit"
                                className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
                            >
                                Add Project
                            </button>
                        </div>
                    </form>
                </div>
            </>
        )
    );
}
